//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'St21WarnList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {},
  data: function data() {
    return {
      pagePath: '/st21/warn',
      pageTitle: '在线监控预警',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'factorName',
        colName: 'factor_name',
        title: '因子名称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'factorVal',
        colName: 'factor_val',
        title: '监测数值',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'warnTime',
        colName: 'warn_time',
        title: '预警时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'warnContent',
        colName: 'warn_content',
        title: '预警内容',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'warnStatus_dictText',
        colName: 'warn_status',
        title: '预警状态',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'checkTime',
        colName: 'check_time',
        title: '确认时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'checkUser',
        colName: 'check_user',
        title: '确认人',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        check: '/st21/warn/check',
        checkBatch: '/st21/warn/checkBatch',
        delete: '/st21/warn/deleteBatch'
      }
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();

      if (ids[0] == '1') {
        this.queryParam.siteId = ids[1];
        this.loadData();
      }
    }
  },
  created: function created() {},
  computed: {},
  methods: {
    loadData: function loadData(arg) {
      this.queryParam.category = '1';
      this.initTableData(arg);
    },
    onDateWarnTime: function onDateWarnTime(value, dateArray) {
      this.queryParam.warnTimeStart = dateArray[0];
      this.queryParam.warnTimeEnd = dateArray[1];
    },
    onDateCheckTime: function onDateCheckTime(value, dateArray) {
      this.queryParam.checkTimeStart = dateArray[0];
      this.queryParam.checkTimeEnd = dateArray[1];
    },
    handleCheck: function handleCheck(record) {
      var ids = record.id;
      var that = this;
      this.$confirm({
        title: '确认',
        content: '是否确认选中数据?',
        onOk: function onOk() {
          getAction(that.url.checkBatch, {
            ids: ids
          }).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.loadData();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          });
        }
      });
    },
    batchCheck: function batchCheck() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择' + this.pageTitle + '记录！');
        return;
      } else {
        var ids = '';

        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }

        var that = this;
        this.$confirm({
          title: '确认',
          content: '是否确认选中' + this.pageTitle + '数据?',
          onOk: function onOk() {
            getAction(that.url.checkBatch, {
              ids: ids
            }).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadData();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    }
  }
};